var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXrp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.846 6h1.985l-4.13 4.405a3.75 3.75 0 0 1-2.7 1.17a3.74 3.74 0 0 1-2.703-1.17L5.163 6h1.991l3.134 3.374c.917.973 2.507.973 3.425 0zM7.127 17.993H5.143l4.155-4.391a3.75 3.75 0 0 1 2.705-1.171a3.75 3.75 0 0 1 2.705 1.171L18.858 18h-1.985l-3.153-3.36a2.374 2.374 0 0 0-3.426 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXrp);
export default __webpack_public_path__ + "static/media/xrp.1104c461e44d2ba2b616b1d1e1ec22c6.svg";
export { ForwardRef as ReactComponent };